export default "__VITE_ASSET__CEamxSab__"